import React, { useState } from 'react';
import styles from './ShareComponent.module.css';



const ShareButton = ({ icon, text, onClick }) => (
  <button className={styles.shareOption} onClick={onClick}>
    <img src={icon} alt="" className={styles.shareIcon} />
    <span className={styles.shareText}>{text}</span>
  </button>
);

const ShareModal = ({ isOpen, onClose, postData }) => {
  const [copyStatus, setCopyStatus] = useState('');

  if (!isOpen) return null;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(`${process.env.REACT_APP_FRONTEND_URL}/post/${postData._id}`);
      setCopyStatus('Link copied!');
      setTimeout(() => {
        setCopyStatus('');
        onClose();
      }, 2000);
    } catch (err) {
      setCopyStatus('Failed to copy');
    }
  };

  const handleNativeShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: postData?.title || 'Check out this post',
          text: postData?.content || 'Check out this post',
          url: `https://fisiko.vercel.app/post/${postData._id}`,
        });
        onClose();
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };



  // Determine if Web Share API is available
  const isWebShareSupported = navigator.share !== undefined;

  return (
    <div className={styles.modalOverlay} onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}>
      <section 
        className={styles.shareContainer} 
        role="dialog" 
        aria-modal="true" 
        aria-labelledby="shareModalTitle"
      >
        <h2 id="shareModalTitle" className={styles.visuallyHidden}>Share Options</h2>
        
        {/* Copy Link button - always show */}
        <ShareButton
          icon="https://cdn.builder.io/api/v1/image/assets/TEMP/e01b8d3c9f054e922b1c956e9cd040c0db1c1492d02afd1a0e545a2849495b3e?apiKey=f523408d85c94fc8913d645c993f4c42&"
          text={copyStatus || "Copy Link"}
          onClick={handleCopyLink}
        />

        {/* Native Share button - show only if supported */}
        {isWebShareSupported && (
          <ShareButton
            icon="https://cdn.builder.io/api/v1/image/assets/TEMP/4858f9b85a81e38d0aa5bf249617c714f8f1bb9a6cec1ee79fa042c7e5dd49b8?apiKey=f523408d85c94fc8913d645c993f4c42&"
            text="Share"
            onClick={handleNativeShare}
          />
        )}

        <button className={styles.cancelButton} onClick={onClose}>
          Cancel
        </button>

        {copyStatus && (
          <div className={styles.statusMessage}>
            {copyStatus}
          </div>
        )}
      </section>
    </div>
  );
};

export default ShareModal;